import { pageHead } from "@/lib/route-head";
import { getAudiencePage } from "@/data/audience-pages";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AudienceLanding = lazy(() => import("@/pages/AudienceLanding"));

export const Route = createFileRoute("/couples-dinner-experiences")({
  head: () => { const p = getAudiencePage("couples-dinner-experiences"); return pageHead({ path: "/couples-dinner-experiences", title: p?.title ?? "Amorette", description: p?.description ?? "" }); },
  component: AudienceLanding,
});
